<div ngbDropdown
     placement="bottom-start bottom-center bottom-end"
     display="dynamic"
     data-cy="ngb-dropdown"
     (openChange)="onToggle($event)">
  <button class="btn p-0 focusable dropdown-trigger"
          ngbDropdownToggle
          [attr.aria-label]="ariaLabel | cxTranslate"
          aria-expanded="false"
          id="return-to"
          aria-haspopup="true"
          data-cy="ngb-toggle">
    <span class="arrow-left ds-icon ds-icon--arrow-left focusable__element"></span>
  </button>
  <div id="return-to-menu" ngbDropdownMenu aria-labelledby="return-to" class="py-1" role="menu">
    <a ngbDropdownItem *ngIf="showReturnToCart"
       [routerLink]="{ cxRoute: 'cart' } | cxUrl"
       data-cy="return-to-cart-link">
      <span class="ds-icon ds-icon--cart"></span> {{'header.returnToCart' | cxTranslate}}
    </a>
    <a ngbDropdownItem
       [href]="componentUrl?.link ? componentUrl.link : configService.getString('urls.sap4me') + '/home'"
       data-cy="return-to-sap4me-link">
      <span class="ds-icon ds-icon--application"></span>
      {{componentUrl?.title ? componentUrl.title : 'header.returnToSap4me' | cxTranslate}}
    </a>
  </div>
</div>
